export default __webpack_public_path__ + "static/media/Neutrif-Studio-Regular.155c072f.ttf";